import React, { memo } from 'react';

import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { IUnitedSections, PDF } from 'constants/businessToolSections';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSection, getBusinessPlanType, getSetActiveSection } from 'store/useBusinessToolStore/selectors';

import { isBusinessToolSection } from 'helpers/businessTool/sections/isBusinessToolSection';
import { isForInvestorsSection } from 'helpers/businessTool/sections/isForInvestorsSection';
import { isOnePageSection } from 'helpers/businessTool/sections/isOnePageSection';
import { isOnePageShortSection } from 'helpers/businessTool/sections/isOnePageShortSection';

import { FormFocusProvider } from './components/FormFocusProvider';
import { forInvestorSections } from './ForInvestorsSections/forInvestorsSections';
import { onePageFormSections } from './OnePageSections/onePageSections';
import { onePageShortFormSections } from './OnePageShortSections/onePageShortSections';
import { forBankSections } from './Sections/forBankSections';

export const deriveActiveSection = (section: IUnitedSections): React.ComponentType | null => {
  if (isBusinessToolSection(section)) {
    return forBankSections[section];
  }

  if (isOnePageSection(section)) {
    return onePageFormSections[section];
  }

  if (isOnePageShortSection(section)) {
    return onePageShortFormSections[section];
  }

  if (isForInvestorsSection(section)) {
    return forInvestorSections[section];
  }

  return null;
};

export const BusinessToolForm: React.FC = memo(() => {
  const activeSection = useBusinessToolStore(getActiveSection);
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);
  const setActiveSection = useBusinessToolStore(getSetActiveSection);
  if (activeSection === PDF.TITLE_PAGE_AND_TABLE_OF_CONTENTS) {
    businessPlanType === BUSINESS_PLAN_TYPES.FOR_BANK
      ? setActiveSection('FOR_BANK_OVERVIEW')
      : setActiveSection('FOR_INVESTORS_OVERVIEW');
  }
  const ActiveSection = deriveActiveSection(activeSection);

  return <FormFocusProvider>{ActiveSection ? <ActiveSection /> : null}</FormFocusProvider>;
});
